// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: var(--sidebar-width);
  height: 100vh;
  background: var(--color-bg-surface);
  border-right: 1px solid var(--color-border-default);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

/* Header / Logo */
.sidebar-header {
  padding-top: var(--spacing-lg);
  padding-left: var(--spacing-xl);
  padding-right: var(--spacing-xl);
  padding-bottom: 1.6rem;
  border-bottom: 1px solid var(--color-border-default);
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.sidebar-logo__icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) saturate(100%) invert(46%) sepia(95%) saturate(2479%)
    hue-rotate(201deg) brightness(99%) contrast(101%);
}

.sidebar-logo__text {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  margin: 0;
  line-height: var(--line-height-tight);
}

/* Sections */
.sidebar-section {
  padding: var(--spacing-lg) var(--spacing-md);
  border-bottom: 1px solid var(--color-border-default);
}

.sidebar-section--projects {
  flex: 1;
  overflow-y: auto;
}

.sidebar-section__title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  padding: 0 var(--spacing-md);
}

/* Smart Views Container */
.sidebar-views {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

/* Sidebar Item (Common for views and projects) */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  user-select: none;
}

.sidebar-item:hover {
  background: var(--color-bg-hover);
}

.sidebar-item--active:hover {
  background: var(--color-bg-active);
}

.sidebar-item--active {
  background: var(--color-bg-active);
}

.sidebar-item--active .sidebar-item__text {
  color: var(--color-primary-text);
  font-weight: var(--font-weight-medium);
}

.sidebar-item--active .sidebar-item__count {
  background: var(--color-primary);
  color: var(--color-text-inverse);
}

/* Drag and drop feedback */
.sidebar-item--drag-over {
  background: var(--color-bg-hover) !important;
  box-shadow: inset 0 0 0 2px var(--color-primary);
  opacity: 0.8;
}

.sidebar-item__icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  opacity: 0.8;
}

.sidebar-item--active .sidebar-item__icon {
  opacity: 1;
  filter: brightness(0) saturate(100%) invert(46%) sepia(95%) saturate(2479%)
    hue-rotate(201deg) brightness(99%) contrast(101%);
}

/* Invert icons in dark theme */
[data-theme="dark"] .sidebar-item__icon {
  filter: invert(1);
}

[data-theme="dark"] .sidebar-item--active .sidebar-item__icon {
  filter: invert(1) brightness(0) saturate(100%) invert(46%) sepia(95%)
    saturate(2479%) hue-rotate(201deg) brightness(99%) contrast(101%);
}

.sidebar-item__text {
  flex: 1;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-item__count {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-regular);
  color: var(--color-text-secondary);
  background: var(--color-bg-hover);
  padding: 2px var(--spacing-sm);
  border-radius: var(--radius-full);
  min-width: 20px;
  text-align: center;
}

/* Projects Header */
.sidebar-projects-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-sm);
}

.sidebar-add-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color var(--transition-fast);
}

.sidebar-add-btn:hover {
  background: var(--color-bg-hover);
}

.sidebar-add-btn__icon {
  width: 16px;
  height: 16px;
}

/* Invert plus icon on dark theme */
[data-theme="dark"] .sidebar-add-btn__icon {
  filter: invert(1);
}

/* Projects List */
.sidebar-projects {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.sidebar-empty {
  padding: var(--spacing-md);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  text-align: center;
}

/* Footer / Settings */
.sidebar-footer {
  padding: var(--spacing-md);
  border-top: 1px solid var(--color-border-default);
}

.sidebar-settings-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-sm) var(--spacing-md);
  border: none;
  background: transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.sidebar-settings-btn:hover {
  background: var(--color-bg-hover);
}

.sidebar-settings-btn__icon {
  width: 18px;
  height: 18px;
}

/* Invert settings icon in dark theme */
[data-theme="dark"] .sidebar-settings-btn__icon {
  filter: invert(1);
}

.sidebar-settings-btn__text {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
}

/* Project Row (with menu button) */
.project-row {
  position: relative;
}

.project-row .sidebar-item {
  position: relative;
  padding-right: 36px;
}

.project-row .sidebar-item__count {
  position: absolute;
  right: 12px;
  transition:
    transform var(--transition-fast),
    opacity var(--transition-fast);
}

/* Project Menu Button */
.project-menu {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.project-menu-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition:
    opacity var(--transition-fast),
    background-color var(--transition-fast);
  flex-shrink: 0;
}

.project-row:hover .project-menu-btn {
  opacity: 1;
}

.project-row:hover .sidebar-item__count {
  transform: translateX(-24px);
}

.project-menu-btn:hover {
  background: var(--color-bg-hover);
}

.project-menu-btn img {
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

[data-theme="dark"] .project-menu-btn img {
  filter: invert(1);
}

.project-menu-btn:hover img {
  opacity: 1;
}

.project-menu-btn.is-open img {
  opacity: 1;
}

[data-theme="dark"] .project-menu-btn.is-open img {
  filter: invert(1);
}

/* Project Menu Dropdown */
.project-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--color-bg-surface);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  min-width: 120px;
  display: none;
  flex-direction: column;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-top: var(--spacing-xs);
}

.project-menu-dropdown.open {
  display: flex;
}

.project-menu-item {
  width: 100%;
  text-align: left;
  padding: var(--spacing-sm) var(--spacing-md);
  border: none;
  background: transparent;
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  font-weight: var(--font-weight-medium);
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.project-menu-item:first-child {
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}

.project-menu-item:last-child {
  border-radius: 0 0 var(--radius-md) var(--radius-md);
}

.project-menu-item:hover {
  background: var(--color-bg-hover);
}

.project-menu-item--danger {
  color: var(--color-danger, #ef4444);
}

.project-menu-item--danger .project-menu-item__icon {
  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)
    brightness(94%) contrast(96%);
}

.project-menu-item--danger:hover {
  background: rgba(239, 68, 68, 0.1);
}

.project-menu-item__icon {
  width: 14px;
  height: 14px;
  opacity: 0.8;
}

[data-theme="dark"] .project-menu-item__icon {
  filter: invert(1);
}

[data-theme="dark"] .project-menu-item--danger .project-menu-item__icon {
  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)
    brightness(94%) contrast(96%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/sidebar.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,aAAa;EACb,mCAAmC;EACnC,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;qDACmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,SAAS;EACT,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,4CAA4C;EAC5C,oDAAoD;AACtD;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV;qDACmD;AACrD;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;AACnB;;AAEA;EACE;qEACmE;AACrE;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,sCAAsC;EACtC,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,kCAAkC;EAClC,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;;kCAEgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV;;2CAEyC;EACzC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mCAAmC;EACnC,6CAA6C;EAC7C,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,mDAAmD;EACnD,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;iCAC+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;iCAC+B;AACjC","sourcesContent":[".sidebar {\n  width: var(--sidebar-width);\n  height: 100vh;\n  background: var(--color-bg-surface);\n  border-right: 1px solid var(--color-border-default);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n/* Header / Logo */\n.sidebar-header {\n  padding-top: var(--spacing-lg);\n  padding-left: var(--spacing-xl);\n  padding-right: var(--spacing-xl);\n  padding-bottom: 1.6rem;\n  border-bottom: 1px solid var(--color-border-default);\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.sidebar-logo__icon {\n  width: 24px;\n  height: 24px;\n  filter: brightness(0) saturate(100%) invert(46%) sepia(95%) saturate(2479%)\n    hue-rotate(201deg) brightness(99%) contrast(101%);\n}\n\n.sidebar-logo__text {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  margin: 0;\n  line-height: var(--line-height-tight);\n}\n\n/* Sections */\n.sidebar-section {\n  padding: var(--spacing-lg) var(--spacing-md);\n  border-bottom: 1px solid var(--color-border-default);\n}\n\n.sidebar-section--projects {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.sidebar-section__title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n  padding: 0 var(--spacing-md);\n}\n\n/* Smart Views Container */\n.sidebar-views {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n/* Sidebar Item (Common for views and projects) */\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  user-select: none;\n}\n\n.sidebar-item:hover {\n  background: var(--color-bg-hover);\n}\n\n.sidebar-item--active:hover {\n  background: var(--color-bg-active);\n}\n\n.sidebar-item--active {\n  background: var(--color-bg-active);\n}\n\n.sidebar-item--active .sidebar-item__text {\n  color: var(--color-primary-text);\n  font-weight: var(--font-weight-medium);\n}\n\n.sidebar-item--active .sidebar-item__count {\n  background: var(--color-primary);\n  color: var(--color-text-inverse);\n}\n\n/* Drag and drop feedback */\n.sidebar-item--drag-over {\n  background: var(--color-bg-hover) !important;\n  box-shadow: inset 0 0 0 2px var(--color-primary);\n  opacity: 0.8;\n}\n\n.sidebar-item__icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n.sidebar-item--active .sidebar-item__icon {\n  opacity: 1;\n  filter: brightness(0) saturate(100%) invert(46%) sepia(95%) saturate(2479%)\n    hue-rotate(201deg) brightness(99%) contrast(101%);\n}\n\n/* Invert icons in dark theme */\n[data-theme=\"dark\"] .sidebar-item__icon {\n  filter: invert(1);\n}\n\n[data-theme=\"dark\"] .sidebar-item--active .sidebar-item__icon {\n  filter: invert(1) brightness(0) saturate(100%) invert(46%) sepia(95%)\n    saturate(2479%) hue-rotate(201deg) brightness(99%) contrast(101%);\n}\n\n.sidebar-item__text {\n  flex: 1;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-item__count {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-regular);\n  color: var(--color-text-secondary);\n  background: var(--color-bg-hover);\n  padding: 2px var(--spacing-sm);\n  border-radius: var(--radius-full);\n  min-width: 20px;\n  text-align: center;\n}\n\n/* Projects Header */\n.sidebar-projects-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-sm);\n}\n\n.sidebar-add-btn {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color var(--transition-fast);\n}\n\n.sidebar-add-btn:hover {\n  background: var(--color-bg-hover);\n}\n\n.sidebar-add-btn__icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* Invert plus icon on dark theme */\n[data-theme=\"dark\"] .sidebar-add-btn__icon {\n  filter: invert(1);\n}\n\n/* Projects List */\n.sidebar-projects {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.sidebar-empty {\n  padding: var(--spacing-md);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-muted);\n  text-align: center;\n}\n\n/* Footer / Settings */\n.sidebar-footer {\n  padding: var(--spacing-md);\n  border-top: 1px solid var(--color-border-default);\n}\n\n.sidebar-settings-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n}\n\n.sidebar-settings-btn:hover {\n  background: var(--color-bg-hover);\n}\n\n.sidebar-settings-btn__icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* Invert settings icon in dark theme */\n[data-theme=\"dark\"] .sidebar-settings-btn__icon {\n  filter: invert(1);\n}\n\n.sidebar-settings-btn__text {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-secondary);\n}\n\n/* Project Row (with menu button) */\n.project-row {\n  position: relative;\n}\n\n.project-row .sidebar-item {\n  position: relative;\n  padding-right: 36px;\n}\n\n.project-row .sidebar-item__count {\n  position: absolute;\n  right: 12px;\n  transition:\n    transform var(--transition-fast),\n    opacity var(--transition-fast);\n}\n\n/* Project Menu Button */\n.project-menu {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.project-menu-btn {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition:\n    opacity var(--transition-fast),\n    background-color var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.project-row:hover .project-menu-btn {\n  opacity: 1;\n}\n\n.project-row:hover .sidebar-item__count {\n  transform: translateX(-24px);\n}\n\n.project-menu-btn:hover {\n  background: var(--color-bg-hover);\n}\n\n.project-menu-btn img {\n  width: 16px;\n  height: 16px;\n  opacity: 0.7;\n}\n\n[data-theme=\"dark\"] .project-menu-btn img {\n  filter: invert(1);\n}\n\n.project-menu-btn:hover img {\n  opacity: 1;\n}\n\n.project-menu-btn.is-open img {\n  opacity: 1;\n}\n\n[data-theme=\"dark\"] .project-menu-btn.is-open img {\n  filter: invert(1);\n}\n\n/* Project Menu Dropdown */\n.project-menu-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: var(--color-bg-surface);\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  min-width: 120px;\n  display: none;\n  flex-direction: column;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  margin-top: var(--spacing-xs);\n}\n\n.project-menu-dropdown.open {\n  display: flex;\n}\n\n.project-menu-item {\n  width: 100%;\n  text-align: left;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: none;\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  font-weight: var(--font-weight-medium);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.project-menu-item:first-child {\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n\n.project-menu-item:last-child {\n  border-radius: 0 0 var(--radius-md) var(--radius-md);\n}\n\n.project-menu-item:hover {\n  background: var(--color-bg-hover);\n}\n\n.project-menu-item--danger {\n  color: var(--color-danger, #ef4444);\n}\n\n.project-menu-item--danger .project-menu-item__icon {\n  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)\n    brightness(94%) contrast(96%);\n}\n\n.project-menu-item--danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.project-menu-item__icon {\n  width: 14px;\n  height: 14px;\n  opacity: 0.8;\n}\n\n[data-theme=\"dark\"] .project-menu-item__icon {\n  filter: invert(1);\n}\n\n[data-theme=\"dark\"] .project-menu-item--danger .project-menu-item__icon {\n  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)\n    brightness(94%) contrast(96%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
